import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import {
  SkeletonbodyTemplate,
  Skeletonitems,
} from '../../appconfig/Settings';
import {
  getSpecificDetails,
  postDataByID,
  updateData,
} from '../../service/ApiService';
import {
  APPROVE_DOCUMENT,
  EDIT_DOCUMENT,
  TAX_LIST_DETAIL,
  UPDATE_TAXPAYER_NOTE,
} from '../../config/ApiConstant';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { TaxListDetailColumns } from '../../appconfig/DatatableSetting';
import { Column } from 'primereact/column';
import { formatDate } from '../../appconfig/AppHelper';
import { InputSwitch } from 'primereact/inputswitch';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import FileUploader from '../../components/FileUploader/FileUploader';
import { validateFileUpload } from '../../config/Validate';
import Loader from '../../components/Loader/Loader';
import ViewSinNumber from '../../components/ViewSinNumber/ViewSinNumber';
import {
  InfoCard,
  Section,
  StatusBadge,
} from '../../components/CommonCompentUi';
import { User, Briefcase, FileText, Receipt } from 'lucide-react';
import { InputText } from 'primereact/inputtext';

interface TaxPayerSpouseDetailProps {
  data?: any;
  loading?: boolean;
  refreshData?: () => void;
}

const TaxPayerSpouseDetail = ({ data, loading, refreshData }: TaxPayerSpouseDetailProps) => {

  // tax payer id
  const { id }: any = useParams();
  const employee_id = id ? atob(id) : null;

  // toast ref
  const toast = useRef<any>(null);

  // tax payer detail obj
  const [userTaxFileData, setUserTaxFileData] = useState<any>(null);

  // filter
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);

  // loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // document list
  const [documentList, setDocumentList] = useState<any>([]);

  // spouse data obj
  const [spouseData, setSpouseData] = useState<any>({});

  // Document status
  const [activeTaxPayerId, setActiveTaxPayerId] = useState<any>(null);
  const [docStatus, setDocStatus] = useState<any>(null);

  // spouse self employed expenses
  const [spouseSelfEmployedExpenseList, setSpouseSelfEmployedExpenseList] =
    useState<any>({});
  const [spouseSelfEmployedOtherExpense, setSpouseSelfEmployedOtherExpense] =
    useState<any>({});

  // spouse wfh expenses
  const [spouseWfhExpense, setSpouseWfhExpense] = useState<any>({});
  const [spouseWfhOtherExpense, setSpouseWfhOtherExpense] = useState<any>({});

  // doc status dialog
  const [isHold, setIsHold] = useState<any>(null);
  const [documentDialog, setDocumentDialog] = useState<boolean>(false);

  // file upload
  const [fileUploadDialog, setFileUploadDialog] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  // error obj
  const [errors, setErrors] = useState<any>({});

  // edit name dialog
  const [editNameDialog, setEditNameDialog] = useState<boolean>(false);
  const [editFirstName, setEditFirstName] = useState<string>('');
  const [editLastName, setEditLastName] = useState<string>('');
  const [editNameLoading, setEditNameLoading] = useState<boolean>(false);
  const [editNameField, setEditNameField] = useState<
    'spouse_first_name' | 'spouse_middle_name' | 'spouse_last_name' | null
  >(null);

  // sin copied state
  const [sinCopied, setSinCopied] = useState<boolean>(false);

  // current year
  const current = new Date();
  const year = current.getFullYear();

  // scroll position
  const scrollPositionRef = useRef(0);

  // Marital status derived state
  const isMarried = userTaxFileData?.dec_marrige_status === 'Married' || userTaxFileData?.dec_marrige_status === 'Living common-law';

  // Condition for manual tax payer with spouse resident
  const manualTaxPayerDetail = userTaxFileData;
  const isShowLimitedFields = userTaxFileData?.data_added_manually == 1;

  // Collapsible sections state
  const [expandedSections, setExpandedSections] = useState<any>({
    spouse: true,
    employment: true,
    employedExpenses: true,
    workFromHomeExpense: true,
    documents: true,
  });

  // useEffect to parse tax payer detail when and data changes
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      parseTaxData(data);
    }
  }, [data]);

  // Handle scroll position in tab
  useLayoutEffect(() => {
    window.scrollTo({
      top: scrollPositionRef.current,
      behavior: 'auto',
    });
  }, [expandedSections]);

  // get tax payer detail
  const parseTaxData = (response: any) => {
    // Parse spouse_details safely
    let spousedetails: any = {};
    let spouseSelfEmployedExpense = {};
    let spouseSelfEmployedOtherExpense = [];
    let spouseWfhExpense = {};
    let spouseWfhOtherExpense = [];

    if (response?.spouse_details) {
      spousedetails = JSON.parse(response.spouse_details);
    }

    if (spousedetails?.spouseSelfEmployedExpenses) {
      spouseSelfEmployedExpense = JSON.parse(
        spousedetails.spouseSelfEmployedExpenses,
      );
    }

    if (spousedetails?.spouseSelfEmployedOtherExpenses) {
      spouseSelfEmployedOtherExpense = JSON.parse(
        spousedetails.spouseSelfEmployedOtherExpenses,
      );
    }

    if (spousedetails?.spouseWFHEmployedExpenses) {
      spouseWfhExpense = JSON.parse(
        spousedetails.spouseWFHEmployedExpenses,
      );
    }

    if (spousedetails?.spouseWFHEmployedOtherExpenses) {
      spouseWfhOtherExpense = JSON.parse(
        spousedetails.spouseWFHEmployedOtherExpenses,
      );
    }

    const spouseDataDocs = response?.spouse_docs;
    setUserTaxFileData(response);
    setDocumentList(spouseDataDocs);
    setSpouseData(spousedetails);

    // spouse self employed expenses
    setSpouseSelfEmployedExpenseList(spouseSelfEmployedExpense);

    // spouse self employed other expenses
    setSpouseSelfEmployedOtherExpense(spouseSelfEmployedOtherExpense);

    // spouse wfh expenses
    setSpouseWfhExpense(spouseWfhExpense);

    // spouse wfh other expenses
    setSpouseWfhOtherExpense(spouseWfhOtherExpense);

    setPageLoad(true);
  };

  // update document status api call
  const updateDocumentStatus = async () => {
    try {
      setSubmitLoading(true);

      //call api
      const response = await postDataByID(APPROVE_DOCUMENT, activeTaxPayerId);

      if (response) {
        setDocumentDialog(false);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message,
        });
        setPageLoad(true);
        setSubmitLoading(false);
        if (refreshData) {
          refreshData();
        }

      }
    } catch (error: any) {
      setPageLoad(false);
      setSubmitLoading(false);
      setDocumentDialog(false);
      toast.current?.show({
        severity: 'error',
        summary: 'Alert',
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
    setDocStatus(true);
  };

  // file upload api call
  const fileUploadSubmit = async () => {
    try {
      const { errors, isError } = validateFileUpload(selectedFile);
      setErrors(errors);
      if (isError) return;
      setSubmitLoading(true);

      const formData: any = new FormData();
      if (selectedFile instanceof File) {
        formData.append('file', selectedFile);
      }

      // api call
      const response = await updateData(
        EDIT_DOCUMENT,
        activeTaxPayerId,
        formData,
      );

      if (response) {
        setFileUploadDialog(false);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message,
        });
        setSubmitLoading(false);
        if (refreshData) {
          refreshData();
        }

        setSelectedFile(null);
      }
    } catch (error: any) {
      setSubmitLoading(false);
      setFileUploadDialog(false);
      setSelectedFile(null);
      toast.current?.show({
        severity: 'error',
        summary: 'Alert',
        detail: error?.response?.data?.message,
      });
    }
  };



  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.file_url) {
      window.open(rowData?.file_url, '_blank');
    } else {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'PDF NOT FOUND',
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );





  // close review status dialog
  const hideDocumentStatusDialog = () => {
    setDocumentDialog(false);
    setActiveTaxPayerId(null);
    setDocStatus(null);
  };

  // close file upload dialog
  const hideFileUploadDialog = () => {
    setFileUploadDialog(false);
    setActiveTaxPayerId(null);
    setSelectedFile(null);
  };

  const handleSinCopy = () => {
    navigator.clipboard.writeText(String(spouseData?.sin_number || "—"));
    setSinCopied(true);
    setTimeout(() => {
      setSinCopied(false);
    }, 5000);
  };

  // open edit name dialog
  const openEditNameDialog = (field: 'spouse_first_name' | 'spouse_middle_name' | 'spouse_last_name') => {
    setEditNameField(field);
    if (field === 'spouse_first_name') {
      setEditFirstName(spouseData?.spouse_first_name || '');
    } else if (field === 'spouse_middle_name') {
      setEditFirstName(spouseData?.spouse_middle_name || '');
    } else {
      setEditLastName(spouseData?.spouse_last_name || '');
    }
    setEditNameDialog(true);
  };

  // hide edit name dialog
  const hideEditNameDialog = () => {
    setEditNameDialog(false);
    setEditFirstName('');
    setEditLastName('');
    setEditNameField(null);
    setEditNameLoading(false);
    setErrors({});
  };

  // save edit name handler
  const saveEditNameHandler = async () => {
    const nameErrors: any = {};
    if (editNameField === 'spouse_first_name' && !editFirstName.trim()) {
      nameErrors['spouse_first_name'] = 'First name is required';
    }
    if (editNameField === 'spouse_middle_name' && !editFirstName.trim()) {
      nameErrors['spouse_middle_name'] = 'Middle name is required';
    }
    if (editNameField === 'spouse_last_name' && !editLastName.trim()) {
      nameErrors['spouse_last_name'] = 'Last name is required';
    }
    if (Object.keys(nameErrors).length > 0) {
      setErrors(nameErrors);
      return;
    }
    try {
      setEditNameLoading(true);
      const payload: any = {};
      const updatedSpouseDetails = { ...spouseData };
      if (editNameField === 'spouse_first_name') {
        payload.spouse_first_name = editFirstName.trim();
        updatedSpouseDetails.spouse_first_name = editFirstName.trim();
      } else if (editNameField === 'spouse_middle_name') {
        payload.spouse_middle_name = editFirstName.trim();
        updatedSpouseDetails.spouse_middle_name = editFirstName.trim();
        if (editFirstName.trim() === '-' || editFirstName.trim() === '') {
          delete payload.spouse_middle_name;
          delete updatedSpouseDetails.spouse_middle_name;
        }
      } else {
        payload.spouse_last_name = editLastName.trim();
        updatedSpouseDetails.spouse_last_name = editLastName.trim();
      }
      payload.spouse_details = JSON.stringify(updatedSpouseDetails);
      const response = await updateData(
        UPDATE_TAXPAYER_NOTE,
        employee_id,
        payload,
      );
      if (response) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message || 'Name updated successfully',
        });
        hideEditNameDialog();
        if (refreshData) {
          refreshData();
        }
      }
    } catch (error: any) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error?.response?.data?.message || 'Failed to update name',
      });
    } finally {
      setEditNameLoading(false);
    }
  };

  // on input file change
  const onInputFileChange = (e: any) => {
    let val = e?.files;

    if (e?.files) {
      val = e.files;
    }

    setSelectedFile(val);
    setErrors({});
  };

  // on status change
  const onStatusChange = (rowData: any, e: any) => {
    setActiveTaxPayerId(rowData?.id);
    setDocStatus(e.target.value);
    setDocumentDialog(true);
    if (rowData.status === 'Approved') {
      setIsHold(1);
    } else {
      setIsHold(0);
    }
  };

  // upload file change
  const onFileUpload = (rowData: any, e: any) => {
    setActiveTaxPayerId(rowData?.id);
    setFileUploadDialog(true);
  };

  // review Template
  const documentStatusTemplate = (rowData: any) => {
    let statusClass: any =
      rowData.status === 'Not Approved' ? 'warning' : 'success';
    return (
      <div className="actions flex flex-column align-items-center">
        <InputSwitch
          className="mr-2 mb-2"
          value={docStatus}
          disabled={rowData?.status === 'Not Approved'}
          checked={rowData?.status === 'Not Approved' ? false : true}
          onChange={(e) => onStatusChange(rowData, e)}
        />
        <Badge
          severity={statusClass}
          value={
            rowData.status === 'Not Approved' ? 'Not Approved' : 'Approved'
          }
          style={{ width: 'fit-content' }}
        ></Badge>
      </div>
    );
  };

  // upload File template
  const uploadFileTemplate = (rowData: any) => {
    return (
      <div className="name">
        <Button
          tooltip={'Upload Doc'}
          tooltipOptions={{ position: 'bottom' }}
          className="ml-2 common-primary-button"
          icon="pi pi-file-edit"
          disabled={rowData?.status === 'Approved'}
          label=""
          onClick={(e) => onFileUpload(rowData, e)}
        />
      </div>
    );
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="tax-payer-modern-container">
        <div className="content-wrapper">
          {userTaxFileData && (
            <>
              {/* Spouse Details */}
              {spouseData &&
                (userTaxFileData?.dec_marrige_status === 'Married' ||
                  userTaxFileData?.dec_marrige_status ===
                  'Living common-law') && (
                  <>
                    <Section
                      title="Spouse Details"
                      icon={User}
                      sectionKey="spouse"
                      scrollPositionRef={scrollPositionRef}
                      expandedSections={expandedSections}
                      setExpandedSections={setExpandedSections}
                    >
                      <div className="grid">
                        <>
                          {!isShowLimitedFields && (
                            <>
                              <div className="col-12 md:col-6">
                                <div className="flex align-items-center mb-2 w-full border-bottom-1 border-100 h-full">
                                  <div className="font-normal mr-2" style={{ width: "50%", minWidth: "130px", color: "#555", fontSize: "14px" }}>SIN Number:</div>
                                  <div style={{ flex: 1 }} className="flex align-items-center gap-2">
                                    <ViewSinNumber
                                      value={spouseData?.sin_number}
                                      label="SIN Number"
                                    />
                                    {spouseData?.sin_number && spouseData?.sin_number !== "-" && spouseData?.sin_number !== "—" && (
                                      <i
                                        className={`pi ${sinCopied ? "pi-check text-green-500" : "pi-copy text-500 hover:text-primary"} cursor-pointer`}
                                        style={{ fontSize: '0.9rem', flexShrink: 0 }}
                                        onClick={handleSinCopy}
                                        title={sinCopied ? "Copied!" : "Copy"}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 md:col-6 mt-2">
                                <InfoCard
                                  label="Date of Birth"
                                  value={
                                    spouseData?.spouse_date_of_birth
                                      ? formatDate(spouseData?.spouse_date_of_birth)
                                      : '—'
                                  }
                                  allowCopy={true}
                                  labelWidth="50%"
                                  pb="pb-3"
                                />
                              </div>

                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="First Name"
                                  value={spouseData?.spouse_first_name || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                  action={
                                    <i
                                      className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                                      style={{ fontSize: '0.9rem' }}
                                      onClick={() => openEditNameDialog('spouse_first_name')}
                                      title="Edit First Name"
                                    />
                                  }
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Middle Name"
                                  value={spouseData?.spouse_middle_name || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                  action={
                                    <i
                                      className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                                      style={{ fontSize: '0.9rem' }}
                                      onClick={() => openEditNameDialog('spouse_middle_name')}
                                      title="Edit Middle Name"
                                    />
                                  }
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Last Name"
                                  value={spouseData?.spouse_last_name || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                  action={
                                    <i
                                      className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                                      style={{ fontSize: '0.9rem' }}
                                      onClick={() => openEditNameDialog('spouse_last_name')}
                                      title="Edit Last Name"
                                    />
                                  }
                                />
                              </div>
                            </>
                          )}
                          <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                            <InfoCard
                              label="Email"
                              value={spouseData?.spouse_email || '—'}
                              allowCopy={true}
                              labelWidth={isMarried ? "29.5%" : "50%"}
                            />
                          </div>
                          {!isShowLimitedFields && (
                            <>
                              <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                                <InfoCard
                                  label="Street Address"
                                  value={spouseData?.street_address || '—'}
                                  allowCopy={true}
                                  labelWidth={isMarried ? "24.5%" : "50%"}
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="City"
                                  value={spouseData?.city || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                />
                              </div>

                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Province"
                                  value={spouseData?.province || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                />
                              </div>

                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Postal Code"
                                  value={spouseData?.postal_code || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Phone Number"
                                  value={spouseData?.spouse_phone || '—'}
                                  allowCopy={true}
                                  labelWidth="50%"
                                />
                              </div>
                            </>
                          )}
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Spouse Canadian Resident"
                              value={
                                (userTaxFileData?.is_spouse_canadian_resident == 1)
                                  ? 'Yes'
                                  : 'No'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          {!isShowLimitedFields && (
                            <div className="col-12 md:col-6">
                              <InfoCard
                                label="Spouse Status In Canada"
                                value={
                                  userTaxFileData?.spouse_canadian_status || '—'
                                }
                                labelWidth="50%"
                              />
                            </div>
                          )}
                        </>
                      </div>
                    </Section>

                    {/* Employment section */}
                    {!isShowLimitedFields && (
                      <Section
                        title="Spouse Employment & Income"
                        icon={Briefcase}
                        sectionKey="employment"
                        scrollPositionRef={scrollPositionRef}
                        expandedSections={expandedSections}
                        setExpandedSections={setExpandedSections}
                      >
                        <div className="badges-container flex gap-3 mb-3">
                          <StatusBadge
                            status={
                              spouseData?.spouse_first_time_form_filling_status ===
                                '1'
                                ? 'First Time Filer'
                                : 'Not First Time Filer'
                            }
                            type="info"
                          />
                          <StatusBadge
                            status={
                              spouseData?.spouse_moved_from_province === '1'
                                ? 'Moved Province'
                                : 'No Province Change'
                            }
                            type={
                              spouseData?.spouse_moved_from_province === '1'
                                ? 'warning'
                                : 'success'
                            }
                          />
                        </div>

                        <div className="grid">
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="First Time Filing"
                              value={
                                spouseData?.spouse_first_time_form_filling_status ===
                                  '1'
                                  ? 'Yes'
                                  : 'No'
                              }
                              labelWidth="60%"
                            />
                          </div>

                          {spouseData?.spouse_first_time_form_filling_status ===
                            '1' && (
                              <>
                                <div className="col-12 md:col-6">
                                  <InfoCard
                                    label="Date of Entry"
                                    value={
                                      spouseData?.date_of_entry
                                        ? formatDate(spouseData?.date_of_entry)
                                        : '—'
                                    }
                                    labelWidth="60%"
                                  />
                                </div>
                                <div className="col-12 md:col-6">
                                  <InfoCard
                                    label="Income From Home"
                                    value={
                                      spouseData?.spouse_income_from_home
                                        ? `$${spouseData?.spouse_income_from_home}`
                                        : '—'
                                    }
                                    highlight
                                    labelWidth="60%"
                                  />
                                </div>
                              </>
                            )}

                          {spouseData?.spouse_moved_from_province === '1' && (
                            <>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Moving Date"
                                  value={
                                    spouseData?.moving_date
                                      ? formatDate(spouseData?.moving_date)
                                      : '—'
                                  }
                                  labelWidth="60%"
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Province From"
                                  value={spouseData?.province_from || '—'}
                                  labelWidth="60%"
                                />
                              </div>
                              <div className="col-12 md:col-6">
                                <InfoCard
                                  label="Province To"
                                  value={spouseData?.province_to || '—'}
                                  labelWidth="60%"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </Section>
                    )}
                  </>
                )}
              {!isShowLimitedFields && (
                <Section
                  title="Spouse Employed Information"
                  icon={Receipt}
                  sectionKey="employedExpenses"
                  scrollPositionRef={scrollPositionRef}
                  expandedSections={expandedSections}
                  setExpandedSections={setExpandedSections}
                >
                  <div className="section-content-wrapper">
                    <div className="grid">
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Is Self Employed Income"
                          value={
                            spouseSelfEmployedExpenseList?.spouse_self_employed_income === "1"
                              ? 'Yes'
                              : 'No'
                          }
                          labelWidth="60%"
                        />
                      </div>

                      {spouseSelfEmployedExpenseList?.spouse_self_employed_income === "1" && (
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Self Employed Income"
                            value={
                              spouseSelfEmployedExpenseList?.spouse_self_employed_amount
                                ? `$${spouseSelfEmployedExpenseList?.spouse_self_employed_amount}`
                                : '—'
                            }
                            labelWidth="60%"
                          />
                        </div>
                      )}
                      {spouseSelfEmployedExpenseList?.spouse_self_employed_income === "1" && (
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Have Gst Number"
                            value={
                              spouseSelfEmployedExpenseList?.spouse_has_gst === "1" ? 'Yes' : 'No'
                            }
                            labelWidth="60%"
                          />
                        </div>
                      )}

                      {spouseSelfEmployedExpenseList?.spouse_has_gst === "1" && (
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Gst Number"
                            value={spouseSelfEmployedExpenseList?.spouse_gst_no || '-'}
                            labelWidth="60%"
                          />
                        </div>
                      )}

                      {spouseSelfEmployedExpenseList?.spouse_self_employed_income === "1" && (
                        <>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Gas Expense"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_gas_expense
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_gas_expense}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Repairs Expense"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_repairs_expense
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_repairs_expense}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Insurance Expense"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_insurance_expense
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_insurance_expense}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Bill Expense"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_phone_bill_expenses
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_phone_bill_expenses}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Meal Expense"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_meal_expenses
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_meal_expenses}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>

                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Car Model"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_car_model
                                  ? `${spouseSelfEmployedExpenseList?.spouse_car_model}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Car Model Year"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_car_model_year
                                  ? `${spouseSelfEmployedExpenseList?.spouse_car_model_year}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Car Purchase Year"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_car_purchase_year
                                  ? `${spouseSelfEmployedExpenseList?.spouse_car_purchase_year}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Car Price Paid"
                              value={
                                spouseSelfEmployedExpenseList?.spouse_car_price_paid
                                  ? `$${spouseSelfEmployedExpenseList?.spouse_car_price_paid}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                        </>
                      )}
                    </div>

                    {/* {selfEmployedOtherExpensesList?.length > 0 && (
                      <>
                        <h4>Self Employed Other Expense</h4>
                        <div className="landlord-income-card">
                          <div className="landlord-grid">
                            {selfEmployedOtherExpensesList?.map((expense: any, index: number) => (
                              <div key={index} className="landlord-item">
                                <div className="landlord-name mb-1">
                                  {" "}
                                  <span className="landlord-name">Expense Name: </span>
                                  {expense?.name ? `${expense?.name}` : "-"}
                                </div>
                                <div className="landlord-amount mb-1">
                                  <span className="landlord-name">Expense Amount: </span>
                                  {!window.cn(expense.amount) ? `$${expense.amount}` : "-"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )} */}

                    {spouseSelfEmployedOtherExpense?.length > 0 && (
                      <div className="mt-4">
                        <h5 className="mb-3">Spouse Self Employed Other Expense</h5>
                        <DataTable
                          value={spouseSelfEmployedOtherExpense}
                          showGridlines
                          stripedRows
                          className="p-datatable-sm"
                          responsiveLayout="scroll"
                        >
                          <Column
                            field="name"
                            header="Expense Name"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) => rowData?.name || '—'}
                          />
                          <Column
                            field="amount"
                            header="Amount"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) =>
                              !window.cn(rowData.amount)
                                ? `$${rowData.amount}`
                                : '—'
                            }
                          />
                        </DataTable>
                      </div>
                    )}
                  </div>
                </Section>
              )}
              {!isShowLimitedFields && (
                <Section
                  title="Spouse Work From Home Employed Expenses"
                  icon={Receipt}
                  sectionKey="workFromHomeExpense"
                  scrollPositionRef={scrollPositionRef}
                  expandedSections={expandedSections}
                  setExpandedSections={setExpandedSections}
                >
                  <div className="section-content-wrapper">
                    <div className="grid">
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Have Work From Home"
                          value={
                            spouseWfhExpense?.spouse_work_from_home === "1" ? 'Yes' : 'No'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      {spouseWfhExpense?.spouse_work_from_home === "1" && (
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Claim Expenses For Work From Home"
                            value={
                              spouseWfhExpense?.spouse_claim_expense === "1" ? 'Yes' : 'No'
                            }
                            labelWidth="80%"
                          />
                        </div>
                      )}

                      {spouseWfhExpense?.spouse_work_from_home === "1" && (
                        <>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Internet Bill"
                              value={
                                spouseWfhExpense?.spouse_internet_bill
                                  ? `$${spouseWfhExpense?.spouse_internet_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Insurance Bill"
                              value={
                                spouseWfhExpense?.spouse_insurance_bill
                                  ? `$${spouseWfhExpense?.spouse_insurance_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Equipement Bill"
                              value={
                                spouseWfhExpense?.spouse_equipment_bill
                                  ? `$${spouseWfhExpense?.spouse_equipment_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Stationery Bill"
                              value={
                                spouseWfhExpense?.spouse_stationery_bill
                                  ? `$${spouseWfhExpense?.spouse_stationery_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Utilities Bill"
                              value={
                                spouseWfhExpense?.spouse_utilities_bill
                                  ? `$${spouseWfhExpense?.spouse_utilities_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Hydro Bill"
                              value={
                                spouseWfhExpense?.spouse_hydro_bill
                                  ? `$${spouseWfhExpense?.spouse_hydro_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Rent Bill"
                              value={
                                spouseWfhExpense?.spouse_rent_bill
                                  ? `$${spouseWfhExpense?.spouse_rent_bill}`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                        </>
                      )}
                    </div>

                    {/* {wfhOtherExpensesList?.length > 0 && (
                      <>
                        <h4>Work From Home Employed Other Expense</h4>
                        <div className="landlord-income-card">
                          <div className="landlord-grid">
                            {wfhOtherExpensesList?.map((expense: any, index: number) => (
                              <div key={index} className="landlord-item">
                                <div className="landlord-name mb-1">
                                  {" "}
                                  <span className="landlord-name">Expense Name: </span>
                                  {expense?.name ? `${expense?.name}` : "-"}
                                </div>
                                <div className="landlord-amount mb-1">
                                  <span className="landlord-name">Expense Amount: </span>
                                  {!window.cn(expense.amount) ? `$${expense.amount}` : "-"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )} */}

                    {spouseWfhOtherExpense?.length > 0 && (
                      <div className="mt-4">
                        <h5 className="mb-3">Work From Home Employed Other Expense</h5>
                        <DataTable
                          value={spouseWfhOtherExpense}
                          showGridlines
                          stripedRows
                          className="p-datatable-sm"
                          responsiveLayout="scroll"
                        >
                          <Column
                            field="name"
                            header="Expense Name"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) => rowData?.name || '—'}
                          />
                          <Column
                            field="amount"
                            header="Amount"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) =>
                              !window.cn(rowData.amount)
                                ? `$${rowData.amount}`
                                : '—'
                            }
                          />
                        </DataTable>
                      </div>
                    )}
                  </div>
                </Section>
              )}
              {/* Documents */}
              {!isShowLimitedFields && (
                <Section
                  title="Spouse Documents"
                  icon={FileText}
                  sectionKey="documents"
                  scrollPositionRef={scrollPositionRef}
                  expandedSections={expandedSections}
                  setExpandedSections={setExpandedSections}
                >
                  <div className="mt-4">


                    {pageLoad ? (
                      <div className="crud-demo">
                        <DataTable
                          value={documentList}
                          showGridlines
                          dataKey="id"
                          stripedRows
                          responsiveLayout="scroll"
                          className="datatable-responsive p-datatble-sm"
                          emptyMessage="No Document Found"
                          filters={globalFieldFilter}
                          onFilter={(e) => setGlobalFieldFilter(e.filters)}
                          removableSort
                        >
                          {TaxListDetailColumns.map((col) => {
                            if (col.field === 'file_url') {
                              return (
                                <Column
                                  key={col.field}
                                  field={col.field}
                                  header={col.header}
                                  headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                  style={{ padding: '7px 10px' }}
                                  body={actionBodyTemplate}
                                />
                              );
                            } else if (col.field === 'type') {
                              return (
                                <Column
                                  key={col.field}
                                  field={col.field}
                                  header={col.header}
                                  headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                  style={{ padding: '7px 10px' }}
                                  body={(rowData) => {
                                    const docType = rowData?.type?.toLowerCase() || '';
                                    const isT4 = docType === 'spouse t4';
                                    return (
                                      <span>
                                        {rowData?.type || '—'}
                                        {isT4 &&
                                          rowData?.page_count
                                          ? ` (${rowData?.page_count} ${rowData?.page_count === 1
                                            ? 'page'
                                            : 'pages'
                                          })`
                                          : ''}
                                      </span>
                                    );
                                  }}
                                />
                              );
                            } else if (col.field === 'review_status') {
                              return (
                                <Column
                                  key={col.field}
                                  field={col.field}
                                  header={col.header}
                                  headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                  style={{ padding: '7px 10px' }}
                                  body={documentStatusTemplate}
                                />
                              );
                            } else if (col.field === 'upload_doc') {
                              return (
                                <Column
                                  key={col.field}
                                  field={col.field}
                                  header={col.header}
                                  headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                  style={{ padding: '7px 10px' }}
                                  body={uploadFileTemplate}
                                />
                              );
                            }
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                              />
                            );
                          })}
                        </DataTable>
                      </div>
                    ) : (
                      <div className="crud-demo">
                        <DataTable value={Skeletonitems}>
                          {TaxListDetailColumns.map((col) => (
                            <Column
                              key={col.field}
                              field={col.field}
                              header={col.header}
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={SkeletonbodyTemplate}
                            />
                          ))}
                        </DataTable>
                      </div>
                    )}
                  </div>
                </Section>
              )}
            </>
          )}
        </div>
      </div >

      {/* Review Dialog */}
      < Dialog
        visible={documentDialog}
        style={{ width: '450px' }
        }
        header="Document Status Update"
        className="mx-3 lg:mx-0"
        modal
        draggable={false}
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDocumentStatusDialog}
            />
            <Button
              label="Confirm"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={updateDocumentStatus}
              loading={submitLoading}
            />
          </>
        }
        onHide={hideDocumentStatusDialog}
      >
        <div className="flex align-items-center justify-content-start ">
          {isHold === 1 && (
            <h5 style={{ fontSize: '16px' }}>
              Note: Are you sure you don't want to approve the document
            </h5>
          )}
        </div>
      </Dialog >

      {/* Upload Dialog */}
      < Dialog
        visible={fileUploadDialog}
        style={{ width: '500px' }}
        header="Upload Document"
        className="mx-3 lg:mx-0"
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideFileUploadDialog}
            />
            <Button
              label="Upload"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={fileUploadSubmit}
              loading={submitLoading}
            />
          </>
        }
        onHide={hideFileUploadDialog}
      >
        <div className="grid">
          <div className="field col-12">
            <label>
              Upload Document <span className="required">*</span>
            </label>
            <FileUploader
              name="file_upload"
              onInputChange={onInputFileChange}
              multiple={false}
              maxSize={10}
              value={selectedFile}
            />
            <small className="p-invalid-txt">{errors?.['selectedFile']}</small>
          </div>
        </div>
      </Dialog >

      {/* edit name dialog component */}
      < Dialog
        visible={editNameDialog}
        style={{ width: '480px' }}
        header={
          editNameField === 'spouse_first_name' ? 'Edit First Name' : editNameField === 'spouse_middle_name' ? 'Edit Middle Name' : 'Edit Last Name'
        }
        className="mx-3 lg:mx-0"
        draggable={false}
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideEditNameDialog}
            />
            <Button
              label="Update"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={saveEditNameHandler}
              loading={editNameLoading}
            />
          </>
        }
        onHide={hideEditNameDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* First Name - visible only when editing first name */}
          {editNameField === 'spouse_first_name' && (
            <div className="field col-12">
              <label htmlFor="edit_first_name">
                First Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_first_name"
                value={editFirstName}
                placeholder="Enter First Name"
                onChange={(e) => {
                  setEditFirstName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, spouse_first_name: '' }));
                }}
                className={errors?.['spouse_first_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['spouse_first_name']}</small>
            </div>
          )}
          {/* Middle Name - visible only when editing middle name */}
          {editNameField === 'spouse_middle_name' && (
            <div className="field col-12">
              <label htmlFor="edit_middle_name">
                Middle Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_middle_name"
                value={editFirstName}
                placeholder="Enter Middle Name"
                onChange={(e) => {
                  setEditFirstName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, spouse_middle_name: '' }));
                }}
                className={errors?.['spouse_middle_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['spouse_middle_name']}</small>
            </div>
          )}
          {/* Last Name - visible only when editing last name */}
          {editNameField === 'spouse_last_name' && (
            <div className="field col-12">
              <label htmlFor="edit_last_name">
                Last Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_last_name"
                value={editLastName}
                placeholder="Enter Last Name"
                onChange={(e) => {
                  setEditLastName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, spouse_last_name: '' }));
                }}
                className={errors?.['spouse_last_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['spouse_last_name']}</small>
            </div>
          )}
        </div>
      </Dialog >
      {/* {pageLoad === false && <Loader />} */}
    </>
  );
};

export default TaxPayerSpouseDetail;
